import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SiteLayout } from "./components/site/SiteLayout";
import Home from "./pages/Home";
import Methode from "./pages/Methode";
import Contact from "./pages/Contact";
import Legal from "./pages/Legal";
import SectionHub from "./pages/SectionHub";
import SubPage from "./pages/SubPage";
import { NAV_SECTIONS } from "./lib/navigation";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SiteLayout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/la-methode-rozier" element={<Methode />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/mentions-legales" element={<Legal />} />
            <Route path="/politique-de-confidentialite" element={<Legal />} />

            {NAV_SECTIONS.map((section) => (
              <Route
                key={section.key}
                path={section.path}
                element={<SectionHub />}
              />
            ))}

            {NAV_SECTIONS.flatMap((section) =>
              section.items.map((item) => (
                <Route key={item.path} path={item.path} element={<SubPage />} />
              ))
            )}

            <Route
              path="*"
              element={
                <div className="pt-[160px] pb-24 container-rozier">
                  <p className="overline mb-4">Erreur 404</p>
                  <h1 className="font-serif text-5xl md:text-6xl text-charcoal font-light">
                    Page introuvable.
                  </h1>
                </div>
              }
            />
          </Routes>
        </SiteLayout>
      </BrowserRouter>
    </div>
  );
}

export default App;
